import React from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { HomeProvider } from '../../context/homeContext';
import Page from '../../../components/Page/Page';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import s from './Support.css';
import withStyles from 'isomorphic-style-loader/withStyles';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

function Support({ data, containerClass }) {
  const currentLocale = useSelector(state => state?.intl?.locale);

  const { data: homeSettingsData, loading: homeLoading } = useQueryResponse({ query: getAllHomePageSettings, ssr: true });

  if (homeLoading) {
    return null; // or a loading spinner
  }

  const homeSettings = {};
  homeSettingsData?.getAllHomePageSettings?.homePageData?.forEach(item => {
    homeSettings[item.name] = item.value;
  });

  const getEditStaticPage = data?.getEditStaticPage;
  const pageBanner = getEditStaticPage?.result?.pageBanner;

  const dynamicStaticContent = getDynamicTitleByLocale({
    dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContent,
    locale: currentLocale
  });

  const content = dynamicStaticContent?.[0]?.content || getEditStaticPage?.result?.content;

  return (
    <HomeProvider value={homeSettings}>
      <div className={containerClass}>
        <div className={s.homeBanner} />
        <Page
          html={content}
          pageBanner={pageBanner}
        />
      </div>
    </HomeProvider>
  );
}

export default withStyles(s)(Support);
